import { sendGTMEvent } from '@next/third-parties/google';

import { LEAD_FORM_PAYLOAD_KEYS } from '@/app/lib/forms/tracking/constants';
import type { LeadFormPayload } from '@/app/lib/forms/tracking/types';
import { isDataLayerAvailable } from '@/tag-manager';
import { CUSTOM_EVENT_DYNAMIC_EVENT } from '@/tag-manager/constants';

const getDevice = () => {
  const width = window.innerWidth;
  if (width < 768) return 'mobile';
  if (width < 1280) return 'tablet';
  return 'desktop';
};

/** One `dynamic-event` push. No typed field values, only allowlisted selections. */
export const trackLeadFormEvent = (
  eventName: string,
  payload: LeadFormPayload
) => {
  if (!isDataLayerAvailable()) return;

  const reset = Object.fromEntries(
    LEAD_FORM_PAYLOAD_KEYS.map((key) => [key, undefined])
  );

  sendGTMEvent({
    ...reset,
    event: CUSTOM_EVENT_DYNAMIC_EVENT,
    event_name: eventName,
    page_path: window.location.pathname,
    device: getDevice(),
    ts: new Date().toISOString(),
    ...payload,
  });
};
